import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useWithdrawStore } from '@/store/useWithdrawStore'
import { useUserStore } from '@/store/useUserStore'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'
import type { CryptoCode } from '@/constants/currencyCodes'

interface ResetWithdrawOnRouteEntryProps {
  cryptoCode?: CryptoCode
}

export const ResetWithdrawOnRouteEntry: React.FC<
  ResetWithdrawOnRouteEntryProps
> = ({ cryptoCode }) => {
  const location = useLocation()
  const resetWithdrawStore = useWithdrawStore(
    (state) => state.resetWithdrawStore,
  )
  const setSelectedCryptoWalletData = useWithdrawStore(
    (state) => state.setSelectedCryptoWalletData,
  )
  const setCryptoAmount = useWithdrawStore((state) => state.setCryptoAmount)
  const setFiatAmount = useWithdrawStore((state) => state.setFiatAmount)

  const wallet = useUserStore((state) => state.wallet)
  const displayCurrency = useAppPreferencesStore(
    (state) => state.displayCurrency,
  )

  useEffect(() => {
    // Сбрасываем суммы при входе на страницу, используя displayCurrency пользователя
    setCryptoAmount({ amount: '0', code: 'USDT' })
    setFiatAmount({ amount: '0', code: displayCurrency?.isin || 'USD' })

    // Если передан cryptoCode, устанавливаем соответствующую валюту
    if (cryptoCode && wallet?.completeCurrencies) {
      const selectedCurrency = wallet.completeCurrencies.find(
        (currency) => currency.code === cryptoCode,
      )

      if (selectedCurrency) {
        setSelectedCryptoWalletData(selectedCurrency)
        setCryptoAmount({ amount: '0', code: selectedCurrency.code })
      }
    } else if (wallet?.completeCurrencies?.length) {
      // Иначе выбираем первую доступную валюту (обычно USDT)
      const defaultCurrency =
        wallet.completeCurrencies.find(
          (currency) => currency.code === 'USDT',
        ) || wallet.completeCurrencies[0]

      setSelectedCryptoWalletData(defaultCurrency)
      setCryptoAmount({ amount: '0', code: defaultCurrency.code })
    }
  }, [
    location.pathname,
    cryptoCode,
    resetWithdrawStore,
    setSelectedCryptoWalletData,
    setCryptoAmount,
    setFiatAmount,
    wallet,
    displayCurrency?.isin,
  ])

  return null
}
